import { useState } from 'react';
import { Search } from 'lucide-react';
import { Input } from './ui/input';
import { Button } from './ui/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';

export const FilterBar = ({ onFilter }) => {
  const [filters, setFilters] = useState({
    listing_type: 'all',
    location: '',
    min_price: '',
    max_price: ''
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    const apiFilters = {
      ...filters,
      listing_type: filters.listing_type === 'all' ? '' : filters.listing_type
    };
    onFilter(apiFilters);
  };

  return (
    <form onSubmit={handleSubmit} data-testid="filter-bar" className="bg-white border border-border p-6 space-y-4">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <div>
          <label className="text-xs uppercase tracking-widest text-muted-foreground font-semibold mb-2 block">Type</label>
          <Select value={filters.listing_type} onValueChange={(value) => setFilters({...filters, listing_type: value})} data-testid="filter-type">
            <SelectTrigger>
              <SelectValue placeholder="Tous" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="all">Tous</SelectItem>
              <SelectItem value="Vente">Vente</SelectItem>
              <SelectItem value="Location">Location</SelectItem>
            </SelectContent>
          </Select>
        </div>

        <div>
          <label className="text-xs uppercase tracking-widest text-muted-foreground font-semibold mb-2 block">Localisation</label>
          <Input
            data-testid="filter-location"
            type="text"
            placeholder="Bruxelles, Anvers..."
            value={filters.location}
            onChange={(e) => setFilters({...filters, location: e.target.value})}
            className="border-border"
          />
        </div>

        <div>
          <label className="text-xs uppercase tracking-widest text-muted-foreground font-semibold mb-2 block">Prix min (€)</label>
          <Input
            data-testid="filter-min-price"
            type="number"
            placeholder="0"
            value={filters.min_price}
            onChange={(e) => setFilters({...filters, min_price: e.target.value})}
            className="border-border"
          />
        </div>

        <div>
          <label className="text-xs uppercase tracking-widest text-muted-foreground font-semibold mb-2 block">Prix max (€)</label>
          <Input
            data-testid="filter-max-price"
            type="number"
            placeholder="1000000"
            value={filters.max_price}
            onChange={(e) => setFilters({...filters, max_price: e.target.value})}
            className="border-border"
          />
        </div>
      </div>

      <Button
        data-testid="filter-submit"
        type="submit"
        className="w-full bg-primary text-primary-foreground hover:bg-primary/90 rounded-full px-8 py-6 text-sm uppercase tracking-widest font-semibold transition-all duration-300"
      >
        <Search className="w-4 h-4 mr-2" />
        Rechercher
      </Button>
    </form>
  );
};